<template>
  <div id="main">
    <div v-if="!successfulSubmit">
      <form id="email" @submit.prevent="submitEmail">
        <p>
          Want to hear the latest features and updates? Join the Rebar mailing list:
        </p>

        <p v-if="errorMessage" id="error-message">
          {{ errorMessage }}
        </p>

        <input type="text" name="email" id="email-input"
            placeholder="Your Email" v-model="email"
        />
        
        <VButton>Sign-up</VButton>
      </form>
    </div>
    <div v-else>
      <h3>{{successMessage}}</h3>
    </div>
  </div>
</template>

<script>
import VButton from '../ui/VButton.vue';
const axios = require('axios');

export default {
  components: {
    VButton
  },
  name: 'EmailCollection',
  props: {
    alwaysShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      email: '',
      errorMessage: "",
      successMessage: "",
      successfulSubmit: false
    }
  },
  mounted() {
    // Hide the component if a submit cookie is present
    if (!this.alwaysShow && this.$cookies.get('email-submitted')) {
      this.successfulSubmit = true;
    }
  },
  methods: {
    async submitEmail() {
      let body = {'email': this.email };
      axios.post(`${this.$api}/emails`, body)
        .then((response) => {
          this.successfulSubmit = true;
          this.$cookies.set('email-submitted', true);
          if (response.status === 200) {
            this.successMessage = "You're already subscribed! We'll be in touch soon.";
          } else {
            this.successMessage = "Thank you! We'll be in touch soon.";
          }
        })
        .catch((error) => {
          console.log(error);
          this.errorMessage = "Error submitting email - please try again";
        });
    },
  },
}
</script>


<style scoped>
#main {
  padding: 20px 0px;
  width: 100%;
}

#email {
  display: flex;
  flex-flow: column nowrap;
  justify-items: space-between;
  align-items: center;
  margin: 0;
}
#email p {
  margin-top: 0;
  width: 75%;
}
#email-input {
  width: 50%;
  min-width: 300px;
  height: 30px;
  text-align: center;
  font-size: 18px;
  margin: 0 0 25px 0;
}

#error-message {
  color: red;
  font-weight: bold;
}
</style>